import {
  PimProductV1StockStatusEnum,
  type PimProductWithVariantsV1,
} from '@redteclab/api/clients/bully'

export const productAccessorVariantsNotForSale = (
  product: PimProductWithVariantsV1,
): boolean => {
  return product.variants.every(
    (variant) =>
      variant.stock_status === PimProductV1StockStatusEnum.OutOfSale ||
      variant.stock_status === PimProductV1StockStatusEnum.NotInCatalog ||
      variant.stock_status === PimProductV1StockStatusEnum.OutOfStock,
  )
}
